import { createUseStyles } from 'react-jss';

export const techFeedbacksTableStyles = createUseStyles({
  container: {

  },
});
